module.exports = __webpack_public_path__ + "src/assets/img/login.09f3797a.jpg";